var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
export var CategoryType;
(function (CategoryType) {
    CategoryType["Images"] = "HAS_IMAGES";
    CategoryType["Categories"] = "HAS_CATEGORIES";
})(CategoryType || (CategoryType = {}));
export var KeyboardCourse;
(function (KeyboardCourse) {
    KeyboardCourse["Basic"] = "BASIC";
    KeyboardCourse["Advance"] = "ADVANCE";
})(KeyboardCourse || (KeyboardCourse = {}));
export const AuthHolderControllerApiAxiosParamCreator = function (configuration) {
    return {
        authHolderControllerGetUserPoolInfo: (cloudId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('authHolderControllerGetUserPoolInfo', 'cloudId', cloudId);
            const localVarPath = `/v1/auth-holder/user-pool`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cloudId !== undefined) {
                localVarQueryParameter['cloudId'] = cloudId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AuthHolderControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthHolderControllerApiAxiosParamCreator(configuration);
    return {
        authHolderControllerGetUserPoolInfo(cloudId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authHolderControllerGetUserPoolInfo(cloudId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const AuthHolderControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthHolderControllerApiFp(configuration);
    return {
        authHolderControllerGetUserPoolInfo(cloudId, options) {
            return localVarFp.authHolderControllerGetUserPoolInfo(cloudId, options).then((request) => request(axios, basePath));
        },
    };
};
export class AuthHolderControllerApi extends BaseAPI {
    authHolderControllerGetUserPoolInfo(cloudId, options) {
        return AuthHolderControllerApiFp(this.configuration).authHolderControllerGetUserPoolInfo(cloudId, options).then((request) => request(this.axios, this.basePath));
    }
}
export const HealthcheckControllerApiAxiosParamCreator = function (configuration) {
    return {
        healthControllerCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/healthcheck`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const HealthcheckControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthcheckControllerApiAxiosParamCreator(configuration);
    return {
        healthControllerCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.healthControllerCheck(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const HealthcheckControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthcheckControllerApiFp(configuration);
    return {
        healthControllerCheck(options) {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
    };
};
export class HealthcheckControllerApi extends BaseAPI {
    healthControllerCheck(options) {
        return HealthcheckControllerApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
}
export const ImageControllerApiAxiosParamCreator = function (configuration) {
    return {
        imageControllerGetCategory: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetCategory', 'id', id);
            const localVarPath = `/v1/images/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetCategoryList: (categoryId, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetCategoryList', 'categoryId', categoryId);
            const localVarPath = `/v1/images/categories`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetImage: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetImage', 'id', id);
            const localVarPath = `/v1/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetImageList: (categoryId, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('imageControllerGetImageList', 'categoryId', categoryId);
            const localVarPath = `/v1/images`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ImageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImageControllerApiAxiosParamCreator(configuration);
    return {
        imageControllerGetCategory(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetCategory(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        imageControllerGetCategoryList(categoryId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetCategoryList(categoryId, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        imageControllerGetImage(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetImage(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        imageControllerGetImageList(categoryId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetImageList(categoryId, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const ImageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImageControllerApiFp(configuration);
    return {
        imageControllerGetCategory(id, options) {
            return localVarFp.imageControllerGetCategory(id, options).then((request) => request(axios, basePath));
        },
        imageControllerGetCategoryList(categoryId, limit, offset, options) {
            return localVarFp.imageControllerGetCategoryList(categoryId, limit, offset, options).then((request) => request(axios, basePath));
        },
        imageControllerGetImage(id, options) {
            return localVarFp.imageControllerGetImage(id, options).then((request) => request(axios, basePath));
        },
        imageControllerGetImageList(categoryId, limit, offset, options) {
            return localVarFp.imageControllerGetImageList(categoryId, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};
export class ImageControllerApi extends BaseAPI {
    imageControllerGetCategory(id, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetCategory(id, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetCategoryList(categoryId, limit, offset, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetCategoryList(categoryId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetImage(id, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetImage(id, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetImageList(categoryId, limit, offset, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetImageList(categoryId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}
export const NotificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        notificationControllerGetNotification: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/notifications`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const NotificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationControllerApiAxiosParamCreator(configuration);
    return {
        notificationControllerGetNotification(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notificationControllerGetNotification(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const NotificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationControllerApiFp(configuration);
    return {
        notificationControllerGetNotification(options) {
            return localVarFp.notificationControllerGetNotification(options).then((request) => request(axios, basePath));
        },
    };
};
export class NotificationControllerApi extends BaseAPI {
    notificationControllerGetNotification(options) {
        return NotificationControllerApiFp(this.configuration).notificationControllerGetNotification(options).then((request) => request(this.axios, this.basePath));
    }
}
export const SchoolControllerApiAxiosParamCreator = function (configuration) {
    return {
        schoolControllerGetSchoolOption: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/schools/option`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        schoolControllerPutSchoolOption: (updateSchoolOptionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('schoolControllerPutSchoolOption', 'updateSchoolOptionDto', updateSchoolOptionDto);
            const localVarPath = `/v1/schools/option`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSchoolOptionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const SchoolControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchoolControllerApiAxiosParamCreator(configuration);
    return {
        schoolControllerGetSchoolOption(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolControllerGetSchoolOption(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolControllerPutSchoolOption(updateSchoolOptionDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const SchoolControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchoolControllerApiFp(configuration);
    return {
        schoolControllerGetSchoolOption(options) {
            return localVarFp.schoolControllerGetSchoolOption(options).then((request) => request(axios, basePath));
        },
        schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
            return localVarFp.schoolControllerPutSchoolOption(updateSchoolOptionDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class SchoolControllerApi extends BaseAPI {
    schoolControllerGetSchoolOption(options) {
        return SchoolControllerApiFp(this.configuration).schoolControllerGetSchoolOption(options).then((request) => request(this.axios, this.basePath));
    }
    schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
        return SchoolControllerApiFp(this.configuration).schoolControllerPutSchoolOption(updateSchoolOptionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map